<div class="text-center m-5" *ngIf="loading; else viewOptionFilterForm">
  <ap-spinner size="3"></ap-spinner>
</div>

<ng-template #viewOptionFilterForm>
    <form class="form-group view-option-form" [formGroup]="filterForm" #modalForm="ngForm">
      <div class="my-3 ">
        <div class="col-lg-3 col-md-4">
          <label for="{{ baseId }}-name" translate>Name</label>
          <input 
            mat-input 
            id="{{ baseId }}-name" 
            class="form-control"
            type="text" 
            formControlName="name"
            name="Name"
            [ngClass]="{'required': true}"
          />
          <div *ngIf="name.invalid" class="incorrect-input">
            <div *ngIf="name.hasError('required')">Name is required.</div>
          </div>
        </div>
  
        <div class="col-lg-3 col-md-4">
          <label for="{{ baseId }}-id" translate>ID</label>
          <input 
            mat-input 
            id="{{ baseId }}-id" 
            class="form-control" 
            type="text" 
            formControlName="externalId"
            name="Id"
          />
        </div>
  
        <div class="col-lg-3 col-md-12">
          <div class="checkbox-btn-group pull-margin">
            <mat-checkbox
              id="{{ baseId }}-active-filter"
              formControlName="inActive"
              translate
            >
            Inactive
          </mat-checkbox>
          </div>
        </div>
      </div>
  
      <div class="col-sm-12 mt-2">
        <label for="{{ baseId }}-id" translate>Scope of Options</label>
        <mat-radio-group class="radio-group" formControlName="scopeOfOptions" >
          <mat-radio-button *ngFor="let option of scopeOptions" [value]="option.value">
            {{option.label}}
          </mat-radio-button>
        </mat-radio-group>
      </div>

      <div class="col-sm-12">
        <hr>
      </div>
  
      <div class="col-sm-12 mt-1">
        <label for="{{ baseId }}-id" translate>Initial Rpn Category Selection</label>
        <mat-radio-group class="radio-group" formControlName="rpnInitialCategory" >
          <mat-radio-button *ngFor="let category of initialRpnCategories" [value]="category.value">
            {{category.label}}
          </mat-radio-button>
        </mat-radio-group>
      </div>
  
      <div class="col-sm-12 mt-1">
        <label for="{{ baseId }}-id" translate>Category Options</label>
        <div class="checkbox-btn-group">
          <div class="checkbox-group">
            <mat-checkbox 
              *ngFor="let option of categoryOptionsList" 
              [formControlName]="option.controlName"
            >
              {{ option.label }}
            </mat-checkbox>
          </div>
        </div>
      </div>
  
      <div class="col-sm-12">
        <hr>
      </div>
  
      <div class="col-lg-4 col-md-6">
        <label for="{{ baseId }}-id" translate>Include Visit Notes for Billing Provider</label>
        <mat-radio-group class="radio-group" formControlName="billingProviderType" >
          <mat-radio-button *ngFor="let option of billingProviderOptions" [value]="option.value">
            {{option.label}}
          </mat-radio-button>
        </mat-radio-group>
      </div>
  
      <div class="col-lg-8 col-md-6">
  
        <div class="form-group">
          <ap-findcontrol 
           [baseId]="baseId + '-billing-provider-'" 
           [findControlId]="'ViewProvider'"
           [placeHolder]=""
           [singleSelect]="false"
           [(selectedPks)]="billingProviderIds" 
           [apFormGroup]="filterForm"
           [controlName]="'billingProvidersFilterList'"
           [disabled]="isBillingProviderDisabled || formProcessType === 'view'"
          ></ap-findcontrol>
        </div>
  
      </div>
  
      <div class="col-sm-12 ">
        <hr>
      </div>
  
      <div class="col-lg-4 col-md-6">
        <label for="{{ baseId }}-id" translate>Include Visit Notes for Rendering Provider</label>
        <mat-radio-group class="radio-group" formControlName="renderingProviderType" >
          <mat-radio-button *ngFor="let option of renderingProviderOptions"  [value]="option.value">
            {{option.label}}
          </mat-radio-button>
        </mat-radio-group>
      </div>
  
      <div class="col-lg-8 col-md-6">
        <div class="form-group">
          <ap-findcontrol 
           [baseId]="baseId + '-rendering-provider'" 
           [findControlId]="'ViewProvider'" 
           [placeHolder]=""
           [selectedPks]="renderingProviderIds" 
           [singleSelect]="false" 
           [apFormGroup]="filterForm"
           [controlName]="'renderingProvidersFilterList'" 
           [disabled]="isRenderingProviderDisabled || formProcessType === 'view'"
           >
          </ap-findcontrol>
        </div>
      </div>
  
      <div class="col-sm-12 ">
        <hr>
      </div>

      <div class="col-lg-4 col-md-6">
        <label for="{{ baseId }}-include-Message-option" translate>Include Message Options</label>
        <mat-radio-group class="radio-group" formControlName="messageType" >
          <mat-radio-button *ngFor="let option of messageProviderOptions"  [value]="option.value">
            {{option.label}}
          </mat-radio-button>
        </mat-radio-group>
      </div>
  
      <div class="col-lg-8 col-md-6 margin-gap">
        <div class="form-group">
          <ap-findcontrol 
            [baseId]="baseId + 'msg-option'"
            [findControlId]="'ListMessageType'"
            [placeHolder]=""
            [(selectedPks)]="messageOptionsIds"
            [singleSelect]="false" 
            [apFormGroup]="filterForm"
            [controlName]="'messageTypesFilterList'" 
            [disabled]="isMessageOptionDisabled || formProcessType === 'view'"
          ></ap-findcontrol>
        </div>
      </div>
    </form>
</ng-template>